interface SpacingItem {
  name: string;
  className: string;
  valuePx: string;
  usage?: string;
}

interface SpacingScaleProps {
  items: SpacingItem[];
}

export function SpacingScale({ items }: SpacingScaleProps) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.name} className="flex items-center gap-4">
          <span className="text-[11px] font-mono text-muted-foreground w-16 shrink-0">
            {item.name}
          </span>
          <div
            className="h-4 rounded bg-primary/70 transition-all"
            style={{ width: item.valuePx }}
          />
          <span className="text-[11px] font-mono text-muted-foreground shrink-0">
            {item.valuePx}
          </span>
          <span className="text-[11px] font-mono text-muted-foreground shrink-0">
            {item.className}
          </span>
          {item.usage && (
            <span className="text-[10px] text-muted-foreground hidden sm:inline">{item.usage}</span>
          )}
        </div>
      ))}
    </div>
  );
}
